var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.7917 7.29175V5.83341C24.7917 5.05987 24.4844 4.318 23.9374 3.77102C23.3904 3.22404 22.6485 2.91675 21.875 2.91675H13.125C12.3515 2.91675 11.6096 3.22404 11.0626 3.77102C10.5156 4.318 10.2083 5.05987 10.2083 5.83341V7.29175H5.83333C5.44656 7.29175 5.07563 7.44539 4.80214 7.71888C4.52865 7.99237 4.375 8.36331 4.375 8.75008C4.375 9.13686 4.52865 9.50779 4.80214 9.78128C5.07563 10.0548 5.44656 10.2084 5.83333 10.2084H7.29167V26.2501C7.29167 27.4104 7.7526 28.5232 8.57307 29.3437C9.39355 30.1641 10.5063 30.6251 11.6667 30.6251H23.3333C24.4937 30.6251 25.6065 30.1641 26.4269 29.3437C27.2474 28.5232 27.7083 27.4104 27.7083 26.2501V10.2084H29.1667C29.5534 10.2084 29.9244 10.0548 30.1979 9.78128C30.4714 9.50779 30.625 9.13686 30.625 8.75008C30.625 8.36331 30.4714 7.99237 30.1979 7.71888C29.9244 7.44539 29.5534 7.29175 29.1667 7.29175H24.7917ZM21.875 5.83341H13.125V7.29175H21.875V5.83341ZM24.7917 10.2084H10.2083V26.2501C10.2083 26.6369 10.362 27.0078 10.6355 27.2813C10.909 27.5548 11.2799 27.7084 11.6667 27.7084H23.3333C23.7201 27.7084 24.091 27.5548 24.3645 27.2813C24.638 27.0078 24.7917 26.6369 24.7917 26.2501V10.2084Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 13.125H16.0417V24.7917H13.125V13.125ZM18.9583 13.125H21.875V24.7917H18.9583V13.125Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.2f2780bd5120ef28b1d080bc47ac8c10.svg";
export { ForwardRef as ReactComponent };